import { render, staticRenderFns } from "./CardGeneric.vue?vue&type=template&id=0b27bc6e&scoped=true"
import script from "./CardGeneric.vue?vue&type=script&lang=js"
export * from "./CardGeneric.vue?vue&type=script&lang=js"
import style0 from "./CardGeneric.vue?vue&type=style&index=0&id=0b27bc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b27bc6e",
  null
  
)

export default component.exports